import React from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';

import { Title } from '../Title';
import { breakpoints, colors } from '../../../constants';

import 'swiper/swiper-bundle.min.css';
SwiperCore.use([Pagination]);

const TipContainer = styled.div``;

interface IProps {
    className?: string;
}

const BaseTipSwiper = ({ className }: IProps) => {
    const tips = [
        'Een aantal uur per dag buiten zijn is goed voor de ontwikkeling van je ogen. Doordat je buiten in de verte kijkt, ontspannen ze even. Vooral als je vaker naar objecten dichtbij kijkt, zoals je laptop, telefoon of boek.',
        'Na iedere 20 minuten beeldschermtijd, kijk je 20 seconden in de verte. Zo geef je jouw ogen even hun welverdiende schermpauze.',
        'Twijfel je na het doen van deze online oogcheck of jouw zicht nog wel helemaal optimaal is? Maak een afspraak bij een Pearle opticien in jouw buurt voor een Goed Zicht Gesprek.',
    ];

    return (
        <div className={className}>
            <Title>Onze tips</Title>
            <TipContainer>
                <Swiper
                    spaceBetween={100}
                    slidesPerView={1}
                    pagination={{ clickable: true }}
                >
                    {tips.map((tip, index) => (
                        <SwiperSlide key={index}>{tip}</SwiperSlide>
                    ))}
                </Swiper>
            </TipContainer>
        </div>
    );
};

export const TipSwiper = styled(BaseTipSwiper)`
    position: relative;
    max-width: 380px;
    padding: 40px 30px 80px;
    background-color: ${colors.greenPrimary};
    color: ${colors.white};

    @media (${breakpoints.smallMin}) {
        padding: 40px 40px 80px;
    }

    ${Title} {
        font-size: 32px;
        margin-bottom: 30px;
    }

    ${TipContainer} {
        width: 100%;
        overflow: hidden;
    }

    // Overriding default Swiper styles
    .swiper-container {
        position: initial;
        line-height: 1.9;
    }

    .swiper-pagination-bullets {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
    }

    .swiper-container-horizontal
        > .swiper-pagination-bullets
        .swiper-pagination-bullet {
        height: 10px;
        width: 10px;
        margin: 0 6px;
    }

    .swiper-pagination-bullet-active {
        background-color: ${colors.white};
        height: 12px;
        width: 12px;
    }
`;
